import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import FileBase64 from "react-file-base64";
import SelectInput from "./SelectInput";

import Button from "./Button";
import TextInput from "./TextInput";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./css/editor.css";
import MyDatePicker from "./DatePickerIta";
import moment from "moment";

export default class AddRataWidget extends React.Component {
  constructor(props) {
    super(props);

    this.rataDateRef = React.createRef();

    this.options = [
      { value: "NON PAGATA", label: "NON PAGATA" },
      { value: "DA VERIFICARE", label: "DA VERIFICARE" },
      { value: "PAGATA", label: "PAGATA" },
    ];

    this.state = {
      importo: "",
      option: { value: "NON PAGATA", label: "NON PAGATA" },
      mese: "", // Nuovo campo per il mese
      numeroRate: 1, // Nuovo campo per il numero di rate da generare
    };
  }

  render() {
    return (
      <div style={{ display: this.props.show === true ? "block" : "none" }}>
        <div style={container}>
          <div style={mainClass}>
            <div
              style={closeBtn}
              onClick={() => {
                this.props.onClose();
              }}
            >
              X
            </div>

            <div style={{ marginLeft: "5px" }}>Data di scadenza:</div>
            <MyDatePicker ref={this.rataDateRef} />

            <TextInput
              name="Importo"
              value={this.state.importo}
              onChange={(text) => {
                this.setState({ importo: text });
              }}
            />

            {/* Nuovo input per il numero di rate da generare */}
            <TextInput
              name="Numero di rate da generare"
              value={this.state.numeroRate}
              onChange={(text) => {
                const numero = parseInt(text) || 1;
                this.setState({ numeroRate: Math.max(1, numero) });
              }}
            />

            {/* Nuovo input per il Mese di riferimento */}
            <TextInput
              name="Mese di riferimento"
              value={this.state.mese}
              onChange={(text) => {
                this.setState({ mese: text });
              }}
            />

            {this.props.isStudent && (
              <SelectInput
                key={Math.random()}
                value={this.state.option}
                name={"Stato:"}
                options={this.options}
                isMulti={false}
                onChange={(option) => {
                  this.setState({ option });
                }}
              />
            )}

            <br />
            <Button
              callback={() => {
                const status = this.state.option.value;
                const importo = parseFloat(this.state.importo);
                if (isNaN(importo)) {
                  alert("Importo non valido");
                  return;
                }
                const rataDate = this.rataDateRef.current.getDate();
                const dataFormattata = moment(rataDate).isValid()
                  ? moment(rataDate).format("DD-MM-yyyy")
                  : null;

                if (!dataFormattata) {
                  alert("Data non valida");
                  return;
                }

                const numeroRate = this.state.numeroRate;

                // Se è solo una rata, usa la logica originale
                if (numeroRate === 1) {
                  this.props.onFinish(
                    dataFormattata,
                    this.state.importo,
                    status,
                    this.state.mese
                  );
                  return;
                }

                // Genera multiple rate
                const rateGenerate = [];
                let dataCorrente = moment(rataDate);

                for (let i = 0; i < numeroRate; i++) {
                  const dataRataFormattata = dataCorrente.format("DD-MM-yyyy");

                  // Calcola il mese di riferimento per ogni rata
                  let meseRiferimento = this.state.mese;
                  if (meseRiferimento && i > 0) {
                    // Se c'è un mese di riferimento, incrementalo per le rate successive
                    const numeroMese = parseInt(meseRiferimento);
                    if (!isNaN(numeroMese)) {
                      meseRiferimento = (numeroMese + i).toString();
                    } else {
                      meseRiferimento = `${meseRiferimento}_${i + 1}`;
                    }
                  }

                  rateGenerate.push({
                    data: dataRataFormattata,
                    importo: this.state.importo,
                    status: status,
                    mese: meseRiferimento,
                  });

                  // Aggiungi un mese per la prossima rata
                  dataCorrente = dataCorrente.add(1, "month");
                }

                // Chiama la callback con le rate generate
                this.props.onFinishMultiple
                  ? this.props.onFinishMultiple(rateGenerate)
                  : this.props.onFinish(
                      dataFormattata,
                      this.state.importo,
                      status,
                      this.state.mese
                    );
              }}
              title="SALVA"
            />
          </div>
        </div>
      </div>
    );
  }
}

const mainClass = {
  position: "fixed",
  top: "25%",
  left: "25%",
  width: "50%",
  border: "1px solid black",
  background: "#ffffff",
  padding: "2%",
};

const container = {
  position: "fixed",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  background: "#ffffff88",
  zIndex: 999,
};

const closeBtn = {
  position: "absolute",
  right: "1%",
  top: "1%",
  cursor: "pointer",
};
